import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-semibold my-5" }, "Nueva contraseña", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Ingresa la nueva contraseña que utilizarás para tu cuenta.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Nueva contraseña:")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "passwordConfirm",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Confirma tu nueva contraseña:")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "small text-danger mt-1 ml-1"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-semibold my-5" }, "Contraseña actualizada", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Tu contraseña ha sido actualizada, ya puedes seguir usando Iwari", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Ir al inicio")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.passwordUpdated)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args))),
          action: "/",
          method: "post"
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.message = '')),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  id: "password",
                  type: "password",
                  class: "form-control",
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              _createElementVNode("p", null, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.message = '')),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                  id: "passwordConfirm",
                  type: "password",
                  class: "form-control",
                  required: ""
                }, null, 544), [
                  [_vModelText, _ctx.passwordConfirm]
                ])
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_vue_recaptcha, {
                  sitekey: "6Lcsa5AfAAAAAPEUFy6kvzt842KAfnjHVahSLkUa",
                  size: "normal",
                  theme: "light",
                  hl: "es",
                  onVerify: _ctx.recaptchaVerified,
                  onExpire: _ctx.recaptchaExpired,
                  onFail: _ctx.recaptchaFailed,
                  ref: "vueRecaptcha",
                  class: "mt-2"
                }, null, 8, ["onVerify", "onExpire", "onFail"])
              ])
            ])
          ]),
          (_ctx.message !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            disabled: !_ctx.verifiedRecaptcha,
            type: "submit",
            class: "btn btn-primary shadow-none"
          }, "Enviar", 8, _hoisted_9)
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.passwordUpdated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}